import React, { PropTypes } from "react";
import { connect } from "react-redux";
import ReactTimeout from "react-timeout";
import classNames from "classnames";
import { bindActionCreators } from "redux";

import * as dataActions from "../../../../utils/data/dataActions";

class MessageStatusToggler extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.toggleStatus = this.toggleStatus.bind(this);
  }

  toggleStatus() {
    const {
      afterToggle,
      dataActions,
      message: { messageId, unread },
    } = this.props;
    const action = !!unread ? "read" : "unread";
    const model = { path: `/v1/messages/${messageId}/${action}` };

    return dataActions.simplePost({ model }).then(() => {
      afterToggle();
    });
  }

  render() {
    const { unread } = this.props.message;

    const actionLinkClasses = classNames({
      "action-icon": true,
      read: !unread,
      unread: !!unread,
    });

    return (
      <span className="message-read-status">
        <span
          ref="action"
          className={actionLinkClasses}
          onClick={this.toggleStatus}
        />
      </span>
    );
  }
}

MessageStatusToggler.propTypes = {
  afterToggle: PropTypes.func,
  dataActions: PropTypes.object,
  message: PropTypes.object,
  setTimeout: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(
  null,
  mapDispatchToProps
)(ReactTimeout(MessageStatusToggler));



// WEBPACK FOOTER //
// ./src/components/dashboard/follow-ups/messages/MessageStatusToggler.js